<template>
  <div>
    <ZtList v-if="courseTabDetails.showType === 4" />
    <div v-else class="courseCard">
      <!-- 轮播 -->
      <Banner :bannerList="bannerList" v-show="bannerList.length" />
      <!-- 长图广告位 -->
      <Advertisement :advertisement="advertisement" />
      <!-- 活动 -->
      <HomeAdvert :advertLists="advertLists" />
      <!-- 视频播放 -->
      <!-- <template v-if="isRouterAlive">
        <CourseCardVideo :index="currentIndex" v-bind="$attrs" :courseTables="courseTables" />
      </template>-->
      <!-- 班型或专业列表 -->
      <div
        class="middleTab courseCardMiddleTab"
        v-if="courseTabDetails.tables && courseTabDetails.tables.length > 0"
      >
        <ul class="middleTabUl">
          <li
            id="middleTabLi"
            :class="currentIndex === index ? 'middleTabActived' : 'middleTabUnActived'"
            v-for="(item, index) in courseTabDetails.tables"
            :key="item.name"
            @click="middleTabLi($event, index, item.valueId, item.name)"
          >
            <p class="middleTabName">{{ item.name }}</p>
            <img
              src="@/assets/img/components/home/tabIcon.png"
              alt
              class="tabIcon"
              v-show="currentIndex === index ? true : false"
            />
          </li>
        </ul>
      </div>
      <!-- 班型或专业描述介绍 -->
      <template v-if="isRouterAlive">
        <CourseCardDesc v-bind="$attrs" :index="currentIndex" :courseTables="courseTables" />
      </template>
      <!-- 产品列表 -->
      <template>
        <van-loading v-show="showLoad" type="spinner" color="#ff6c02" />
        <div class="hotCourse" v-if="courseInfoData.length > 0 && isCourseCard === '1'">
          <div v-for="(item, keys) in courseInfoData" :key="keys">
            <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
            <HotCourseCard v-else :key="keys" :item="item" />
          </div>
        </div>
        <div v-else-if="courseInfoData.length <= 0 && isCourseCard === '2'" class="nullCourse">
          <EmptyData :emptyName="'noProductList'" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { reqMajorAd, reqProducts, reqAdvertPlaying } from '@/api/home';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import { reqCombinationlist } from '@/api/combination';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Advertisement from '@/pages/arkHome/components/advertisement.vue';
import HomeAdvert from '@/pages/arkHome/components/homeAdvert.vue';
import CourseCardDesc from './components/courseCardDesc.vue';
// import CourseCardVideo from './components/courseCardVideo.vue';
import ZtList from './components/ztList.vue';
import Banner from './components/bannerVant.vue';

export default {
  inheritAttrs: false,
  components: {
    // CourseCardVideo,
    CourseCardDesc,
    HotCourseCard,
    CombinationCard,
    ZtList,
    EmptyData,
    Banner,
    Advertisement,
    HomeAdvert,
  },

  data() {
    return {
      currentIndex: 0,
      courseTabDetails: [],
      courseTables: [],
      courseInfoData: [],
      CourseCardList: [],
      valueId: '',
      page: 1,
      isRouterAlive: true,
      isCourseCard: '0',
      showLoad: true,
      bannerList: [],
      advertLists: [], // 胶囊区
      advertisement: {}, // 长图广告位
    };
  },

  // 父组件中返回要传给下级的数据
  provide() {
    return {
      reload: this.reload,
    };
  },
  watch: {
    courseTabDetails(data) {
      console.log(111, data);
      const { bannerCode, capsuleOneCode, capsuleTwoCode } = data;
      this.getBanner([bannerCode, capsuleOneCode, capsuleTwoCode]);
    },
  },
  methods: {
    // 请求广告位、长胶囊区、短胶囊区
    async getBanner(code) {
      // console.log('code', code);
      if (!code) return;
      const res = await reqAdvertPlaying(code);
      if (res.code === 0 && res.data) {
        // this.bannerList = res.data[0].advertisingContentWebInfoRespVOS || [];
        this.bannerList = res.data?.find(
          (item) => item.adCode === code[0],
        )?.advertisingContentWebInfoRespVOS || [];
        // 胶囊区长图广告位
        this.advertisement = res.data?.find(
          (item) => item.adCode === code[1],
        )?.advertisingContentWebInfoRespVOS[0];
        // 请求胶囊区短广告位
        this.advertLists = res.data?.find(
          (item) => item.adCode === code[2],
        )?.advertisingContentWebInfoRespVOS || [];
        // console.log('筛选数据banner', this.bannerList);
        // console.log('筛选数据长胶囊', this.advertisement);
        // console.log('筛选数据短胶囊', this.advertLists);
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    middleTabLi(e, index, valueId, title) {
      const { courseTabDetails } = this;
      this.currentIndex = index;
      this.valueId = valueId;
      this.courseTables = courseTabDetails.tables[this.currentIndex];
      this.valueId = courseTabDetails.tables[this.currentIndex].valueId;
      this.isCourseCard = '0';
      this.courseInfoData = [];
      this.page = 1;
      this.changeTab += 1;
      this.resetProductData(this.courseInfoData);
      this.courseDetailsRequest();
      this.reload();
      // eslint-disable-next-line no-undef
      gio('evar.set', 'courseList_evar', title);
    },
    // courseCard
    async courseDetailsRequest() {
      this.showLoad = true;
      this.reqRecomedCourse();
    },

    // 进入详情
    enterDetails(courseInfo) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail ', { courseId: courseInfo.productId }, false);
        return;
      }
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: courseInfo.productId,
        },
      });
    },

    // 自定义数据格式
    // eslint-disable-next-line consistent-return
    resetProductData(courseList, type = 1) {
      courseList.forEach((item) => {
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
      });
      if (type === 1) {
        this.courseInfoData = [...this.courseInfoData, ...courseList];
      } else {
        return courseList;
      }
    },
    reqRecomedCourse() {
      const { recommend, recommendId } = this.courseTabDetails;
      if (recommend) {
        const idx = this.currentIndex;
        const { recommendId } = recommend?.[idx];
        this.getMajorCourse(recommendId);
      } else if (recommendId) {
        this.getMajorCourse(recommendId);
      }
    },
    // 专业课广告位课程列表查询
    async getMajorCourse(id) {
      const { code, data } = await reqMajorAd(id);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      } else {
        this.isCourseCard = '2';
        this.showLoad = false;
      }
    },
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};
      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetProductData(res?.data || [], 2);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse;
        this.showLoad = false;
        this.isCourseCard = allCourse.length ? '1' : '2';
      });
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
  },
  created() {
    const { courseTabDetails } = this.$attrs;
    this.courseTabDetails = courseTabDetails;
    // console.log(courseTabDetails)
    if (courseTabDetails?.tables) {
      this.courseTables = courseTabDetails.tables[this.currentIndex];
      this.valueId = courseTabDetails.tables[this.currentIndex].valueId;
    }

    this.courseDetailsRequest(this.page, 10);
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#f9f9f9');
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
};
</script>
<style lang="scss" scoped>
.courseCard {
  // min-height: 800px;
  ::v-deep .banner {
    padding: 0;
  }
  ::v-deep .pxindBox {
    padding: 16px 0;
  }
  ::v-deep .advertisement {
    margin-bottom: 20px;
    padding: 0;
  }
}
.middleTab {
  padding: 0 0 20px 0;
  .middleTabUl {
    display: flex;
    flex-wrap: wrap;

    #middleTabLi {
      position: relative;
      width: 155px;
      height: 54px;
      margin: 0 12px 18px 0;
      line-height: 54px;
      text-align: center;
      border-radius: 7px;
      .middleTabName {
        padding-left: 10px;
        overflow: hidden;
        font-weight: 400;
        font-size: 25px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tabIcon {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 36px;
        height: 36px;
      }
    }
    #middleTabLi:nth-child(4n) {
      margin-right: 0;
    }
    .middleTabUnActived {
      color: #333;
      background: rgba(132, 132, 132, 0.1);
      border: 2px solid #eaeaea;
    }
    .middleTabActived {
      color: #ff6c02;
      background: rgb(254, 240, 231);
      border: 2px solid #ff6c02;
    }
  }
}
.hotCourse {
  min-height: 800px;
}

.nullCourse {
  ::v-deep .emptyIndent {
    height: 500px;
    padding-top: 40px;
    .product {
      display: none;
    }
  }
}

::v-deep .van-skeleton {
  margin-top: 10px;
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 6px;
}
::v-deep .van-loading {
  margin: 40px 0;
  text-align: center;
}
</style>
